const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const CheckMail = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CHECK_MAIL_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'CHECK_MAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default CheckMail;